import { Injectable } from "@angular/core";
import { ApiBaseService } from "./api-base.service";
import { GetProjectListResultModel } from "../interfaces/entities/project";

@Injectable({
  providedIn: "root",
})
export class ProjectListService {
  constructor(private service: ApiBaseService) {}

  async getProjectList(payLoad: Record<string, unknown>, showLoader = true): Promise<GetProjectListResultModel> {
    return this.service.httpRequest(
      "ProjectListService/GetProjectList",
      payLoad,
      true,
      showLoader
    );
  }

  async getProjectTaskList(payLoad: any): Promise<any> {
    return this.service.httpRequest(
      "ProjectListService/GetProjectTaskList",
      payLoad,
      true,
      true
    );
  }
}
